module.exports = __webpack_public_path__ + "img/1376010865.9b692587.jpg";